import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { DifferencePoint } from 'routes/HowWeAreDifferent/components/Point/DifferencePoint'
import { DifferenceFlows } from 'routes/HowWeAreDifferent/components/Flows/DifferenceFlows'
import classes from './DifferenceEmbeddedIPaaS.module.scss'

export const DifferenceEmbeddedIPaaS = () => {
  return (
    <Block as={'section'} divider={'mobile'} className={classes.section}>
      <hgroup>
        <Heading
          as={'h3'}
          size={'sm'}
          center
          balance
          className={classes.subject}
        >
          Universal Integration Layer vs Embedded iPaaS
        </Heading>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Build integration logic fast, but make&nbsp;it&nbsp;work across every
          application at once
        </Heading>
      </hgroup>

      <DifferencePoint />
      <DifferenceFlows />
    </Block>
  )
}
